module.exports = __webpack_public_path__ + "img/春节大促_33.7b7d34ea.png";